import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Only add auth header to API requests (skip static assets like i18n files)
    if (!request.url.includes('/api/')) {
      return next.handle(request);
    }

    const isAuthRequest = request.url.includes('/api/auth/');

    // add authorization header with jwt token if available
    const currentUser = this.authenticationService.currentUserValue;
    if (!isAuthRequest && currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
    }

    return next.handle(request);
  }
}
